import {Nullable} from "@/general/custom-types/CustomTypes";

export class DownloadFormModel {
  identifier?: Nullable<string>;

  constructor(identifier?: Nullable<string>) {
    this.identifier = identifier;
  }
}
